<template>
  <div class="top-header" v-if="userStore.authUser !== null && userStore.authUser.access_token">
    <div class="header">
      <div class="left-menu">
        <ul class="menus">
          <li class="menu-main-dashboard">
            <router-link to="dashboard">
              <div class="menu">
                <div class="logo-image">
                  <img src="~styles/img/eg-logo.jpg" alt="logo" />
                </div>
                <!-- eo logo image -->

                <div class="detail">
                  <h2>EGMS 3.1</h2>
                  <p>{{ user_number }}</p>
                </div>
              </div>
            </router-link>
          </li>

          <li class="menu-dashboard">
            <router-link
              to="conversation"
              v-bind:class="{ 'active-nav': $route.path == '/conversation' }"
            >
              <div class="menu">
                <div class="menu-icon">
                  <img src="~styles/img/conversation.svg" alt="setup" />
                </div>

                <div class="menu-detail">
                  <h2>Chat</h2>
                  <p>Messages</p>
                </div>
              </div>
            </router-link>
          </li>

          <li class="menu-dashboard">
            <router-link
              to="contacts"
              v-bind:class="{
                'active-nav':
                  $route.path == '/contacts' ||
                  $route.path == '/autoresponse' ||
                  $route.path == '/campaign'
              }"
            >
              <div class="menu">
                <div class="menu-icon">
                  <img src="~styles/img/engage.svg" alt="setup" />
                </div>

                <div class="menu-detail">
                  <h2>Engage</h2>
                  <p>People</p>
                </div>
              </div>
            </router-link>
          </li>

          <li class="menu-dashboard">
            <router-link
              to="analytics"
              v-bind:class="{ 'active-nav': $route.path == '/dashboard' }"
            >
              <div class="menu">
                <div class="menu-icon">
                  <img src="~styles/img/analytic.svg" alt="analytics" />
                </div>

                <div class="menu-detail">
                  <h2>analytics</h2>
                  <p>business intelligence</p>
                </div>
              </div>
            </router-link>
          </li>

          <li class="menu-dashboard">
            <router-link
              to="manageleads"
              v-bind:class="{ 'active-nav': $route.path == '/manageleads' }"
            >
              <div class="menu">
                <div class="menu-icon">
                  <img src="~styles/img/conversation.svg" alt="analytics" />
                </div>

                <div class="menu-detail">
                  <h2>Leads</h2>
                  <p>Phone Numbers</p>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- eo left menu -->

      <div class="right-menu">
        <ul>
          <li class="user">
            <p>{{ user_name }}</p>
            <h3>{{ client_name }}</h3>
          </li>

          <li class="user-img">
            <div class="profile-img">
              <img src="~styles/img/khumbu.jpg" alt />
            </div>
          </li>

          <li class="gems">
            <h2>
              <img src="~styles/img/gems.png" alt />
              {{ user_gems }}
            </h2>
          </li>

          <li class="dropdown-profile">
            <div class="profile-dropdown">
              <div class="dropdown">
                <button
                  class="btn btn-primary dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                >
                  <i class="el-icon-caret-bottom"></i>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <router-link to="setting">Settings</router-link>
                  </li>
                  <li>
                    <a v-on:click="handleLogout()">Log Out</a>
                  </li>
                  <!-- <li><a @click="changeUser = true">Change User</a></li> -->
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- eo right menu -->

      <div class="responsive-menu">
        <ul>
          <li class="icon">
            <span style="font-size:30px;cursor:pointer" @click="showNav = !showNav">&#9776;</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- eo header -->

    <!-- overlay navigation -->
    <div id="myNav" class="overlay" v-bind:class="{ showNav: showNav }">
      <a href="javascript:void(0)" class="closebtn" @click="showNav = !showNav">&times;</a>
      <div class="overlay-content">
        <ul>
          <li class="profile">
            <img src="~styles/img/khumbu.jpg" alt />
            <p class="name">{{ user_name }}</p>
            <h4 class="client-name">{{ client_name }}</h4>
            <p class="gems">
              <img src="~styles/img/grayIcons/gems.png" alt />
              {{ user_gems }}
            </p>
          </li>
          <li v-on:click="closenav()">
            <router-link to="dashboard">Dashboard</router-link>
          </li>
          <li v-on:click="closenav()">
            <router-link to="conversation">Chat</router-link>
          </li>
          <li v-on:click="closenav()">
            <router-link to="contacts">Engage</router-link>
          </li>
          <li v-on:click="closenav()">
            <router-link to="analytics">Analytics</router-link>
          </li>
          <li v-on:click="closenav()">
            <router-link to="manageleads">Leads</router-link>
          </li>
          <li v-on:click="closenav()">
            <router-link to="setting">Setting</router-link>
          </li>
          <li v-on:click="closenav()">
            <a v-on:click="handleLogout()">Logout</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- eo overlay nav -->

    <!-- for changeing user -->
    <el-dialog title="Change User" :visible.sync="changeUser" width="30%">
      <ul class="change-user">
        <li>
          <a href>
            <img src="~styles/img/khumbu.jpg" alt />
            9801223300
          </a>
        </li>

        <li>
          <a href>
            <img src="~styles/img/khumbu.jpg" alt />
            9801223300
          </a>
        </li>

        <li>
          <a href>
            <img src="~styles/img/khumbu.jpg" alt />
            9801223300
          </a>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>

<style lang="scss">
// .right-menu:hover .dropdown-menu{
//     display: block!important;
//     a{
//         cursor: pointer;
//     }
// }

.showNav {
  width: 100% !important;
}
</style>

<script>
import axios from "axios";
import {
  getClientDetailUrl,
  getClientGemlUrl,
  getHeader
} from "./../../config";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      userStore: state => state.userStore
    })
  },
  data() {
    return {
      changeUser: false,
      showNav: false,
      user_number: "",
      user_name: "",
      user_gems: "",
      client_name: ""
    };
  },
  methods: {
    handleLogout() {
      this.$store.dispatch("clearAuthUser");
      window.sessionStorage.removeItem("authUser");
      window.sessionStorage.removeItem("mycontact");
      this.$router.push({ name: "login" });
    },

    closenav: function() {
      this.showNav = false;
    }
  },
  mounted() {
    axios.get(getClientDetailUrl, { headers: getHeader() }).then(Response => {
      (this.user_number = Response.data.data.number),
        (this.client_name = Response.data.data.name),
        (this.user_name = Response.data.data.username),
        window.sessionStorage.setItem(
          "mycontact",
          JSON.stringify(this.user_number)
        );
    }),
      axios.get(getClientGemlUrl, { headers: getHeader() }).then(Response => {
        this.user_gems = Response.data.data.gems_total.gems_remaining;
      }),
      window.setInterval(() => {
        axios.get(getClientGemlUrl, { headers: getHeader() }).then(Response => {
          if (this.user_gems != Response.data.data.gems_total.gems_remaining) {
            this.user_gems = Response.data.data.gems_total.gems_remaining;
          }
        });
      }, 10000);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/topheader.vue